import { render, staticRenderFns } from "./ServiceFlipCarousel.vue?vue&type=template&id=7d50a670"
import script from "./ServiceFlipCarousel.vue?vue&type=script&lang=js"
export * from "./ServiceFlipCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports